import _slicedToArray from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import { useEventListener, useIsomorphicLayoutEffect } from '..';
function useScreen() {
  var getScreen = function getScreen() {
    if (typeof window !== 'undefined' && window.screen) {
      return window.screen;
    }
    return undefined;
  };
  var _useState = useState(getScreen()),
    _useState2 = _slicedToArray(_useState, 2),
    screen = _useState2[0],
    setScreen = _useState2[1];
  function handleSize() {
    setScreen(getScreen());
  }
  useEventListener('resize', handleSize);
  useIsomorphicLayoutEffect(function () {
    handleSize();
  }, []);
  return screen;
}
export default useScreen;